import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b8fd87f4&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TravelCard: require('/srv/rir-platform/tourism/src/tourism-front/components/common/TravelCard/index.vue').default,Button: require('/srv/rir-platform/tourism/src/tourism-front/components/common/Button/index.vue').default,EmptyEntity: require('/srv/rir-platform/tourism/src/tourism-front/components/common/EmptyEntity/index.vue').default})
